<template>
  <div class="" >
    <button class="accordion text-lg font-semibold">{{ title }}</button>
    <div class="panel">
     
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title"],
  methods: {
    snake_case_string(str) {
      return (
        str &&
        str
          .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
          .map((s) => s.toLowerCase())
          .join("_")
      );
    },
  },
};
</script>

<style scoped>
.accordion {
  color: #10233E;
  cursor: pointer;
  padding: 10px;
  width: 100%;
  border: none;
  margin: auto 0;
  text-align: left;
  outline: none;
  font-size: 15px;
  transition: 0.4s;
}

.active,
.accordion:hover {
  /* background-color: #ccc; */
  font-weight: bold;
}

.a-box {
  box-shadow: 0px 0px 10px 2px rgb(0 0 0 / 4%);
  border-radius: 8px;
  /* padding: 1rem; */
  background-color: white;
  border-radius: 10px;
}
.panel {
  background-color: white;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.2s ease-out;
  height: 100%;
}
.accordion::after {
  content:  url(./collapse.svg)" Collapse"; /* Unicode character for "plus" sign (+) */
  font-size: 16px;
  color:#fcc210;
  float: right;
  margin-left: 5px;
}

.active::after {
  content:  url(./expand.svg)" Expand"; /* Unicode character for "minus" sign (-) */
  color:#10233E;
}
</style>
